var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F5222D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8275 9.5C21.495 8.165 20.8275 7.5 20 7.5C19.1725 7.5 18.505 8.16625 17.1725 9.5C16.3725 10.3 15.58 10.67 14.44 10.67C13.445 10.67 12.0275 10.4775 11.25 11.2613C10.4775 12.04 10.67 13.4513 10.67 14.44C10.67 15.58 10.2988 16.3725 9.49875 17.1725C8.16625 18.505 7.5 19.1725 7.5 20C7.5 20.8275 8.16625 21.495 9.5 22.8275C10.395 23.7238 10.67 24.3025 10.67 25.56C10.67 26.555 10.4775 27.9725 11.2613 28.75C12.04 29.5213 13.4513 29.33 14.44 29.33C15.6538 29.33 16.24 29.5675 17.1063 30.4338C17.8438 31.1713 18.8325 32.5 20 32.5C21.1675 32.5 22.1563 31.1713 22.8938 30.4338C23.7613 29.5675 24.3463 29.33 25.56 29.33C26.5488 29.33 27.96 29.5225 28.7387 28.75M28.7387 28.75C29.5225 27.9725 29.33 26.555 29.33 25.56C29.33 24.3025 29.605 23.7238 30.5 22.8275C31.8338 21.495 32.5 20.8275 32.5 20C32.5 19.1725 31.8337 18.505 30.5012 17.1725M28.7387 28.75H28.75M15 17.885C15 17.885 17.8125 17.5 20 22.5C20 22.5 26.3238 10 32.5 7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationRound);
export default __webpack_public_path__ + "static/media/certification-round.5fcd2dbbcdbc6cb739270d2994d22986.svg";
export { ForwardRef as ReactComponent };